import React from "react";
import TestimonialItem from "./TestimonialItem";
import SectionTitle from "../../UI/SectionTitle";
import quoteIcon from "../../../assets/img/icons/quote.png";
import TestimonialData from "../../../data/Testimonials/home-new.json";
import SlickSlider from "../../UI/Slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick.css";
const NextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrows custom-arrow-rights`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <svg
        width="45"
        height="45"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 18L15 12L9 6"
          stroke="#EF586F"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <div
      className={`${className} custom-arrows custom-arrow-lefts`}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <svg
        width="45"
        height="45"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 18L9 12L15 6"
          stroke="#EF586F"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
function Testimonials() {
  const settings = {
    slidesToShow: 1,
    arrows: true,
    dots: true,
    autoplay: true,
    autoplaySpeed: 3000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    className: "testimonial-content--3 testimonial-grid",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 1,
          nextArrow: <NextArrow />,
          prevArrow: <PrevArrow />,
        },
      },
    ],
  };

  return (
    <div className="testimonial-area bg-offwhite tp50 ts50">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 m-auto text-center">
            <SectionTitle
              title="Happy Stories"
              heading=""
              image={require("../../../assets/img/separator4.png")}
            />
          </div>
        </div>

        <div className="row align-items-center testimonials_home">
          <div className="col-lg-8 m-auto">
            <div className="testimonial-content-wrap m-0 pl-0">
              <SlickSlider settings={settings}>
                {TestimonialData.map((testimonial) => (
                  <div key={testimonial.id} className="testimonial_item_wrap">
                    <div className="testimonial-item testimonial-item--3 testimonials_new">
                      <div className="testimonial_item_img">
                        <img src="/images/google-01-webp.webp" alt="google" />
                        <img src="/images/5-star.png" alt="5 star" />
                      </div>
                      <div className="testimonial-txt">
                        <p>{testimonial.quote}</p>
                        <h5 className="client-name">
                          <h3>{testimonial.author}</h3>
                        </h5>
                      </div>
                    </div>
                  </div>
                ))}
              </SlickSlider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Testimonials;
